import { useMemo } from 'react'

const shadeTotals: Record<number, number> = {
  25: 604,
  50: 607,
  100: 572,
  200: 543,
  300: 474,
  400: 475,
  500: 441,
  600: 352,
  700: 276,
  800: 220,
  900: 139,
}

const shadeDifferences: Record<number, number> = Object.keys(
  shadeTotals
).reduce(
  (acc, cur) => {
    acc[Number(cur)] = shadeTotals[Number(cur)] - shadeTotals[500]
    return acc
  },
  {} as Record<number, number>
)

export function useAccents(red: number, green: number, blue: number) {
  const total = red + green + blue

  const accents: Record<number, string> = useMemo(() => {
    const _accents: Record<number, string> = {}
    const quotients = {
      red: red / total,
      green: green / total,
      blue: blue / total,
    }

    const rgbPiece = (val: number) => {
      const floored = Math.floor(val)
      if (floored < 0) return 0
      else if (floored > 255) return 255
      else return floored
    }

    const createAccent = ({ level = 600 }) => {
      const accentSum = total + shadeDifferences[level]
      return `${rgbPiece(quotients.red * accentSum)} ${rgbPiece(
        quotients.green * accentSum
      )} ${rgbPiece(quotients.blue * accentSum)}`
    }

    Object.keys(shadeTotals).forEach((_level: string) => {
      const level = Number(_level)
      _accents[level] = createAccent({ level })
    })
    return _accents
  }, [blue, green, red, total])

  return accents
}
